module.exports = __webpack_public_path__ + "assets/icons/Icon-population.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Icon-population.png
// module id = 528
// module chunks = 0